import * as z from "zod";

import {
  partnerIdSchema,
  partnerStatusSchema,
  partnerSummarySchema,
} from "./shared";

/**
 * Suspending blocks the partner's API tokens and its users' portal
 * sessions at once, since both check the partner's status on every call.
 */
export const updatePartnerStatus = {
  name: "updatePartnerStatus" as const,
  input: z.object({ partnerId: partnerIdSchema, status: partnerStatusSchema }),
  output: z.object({ partner: partnerSummarySchema }),
};
